import { render } from "./ManageAccountLanguage.vue?vue&type=template&id=c54872d2&scoped=true"
import script from "./ManageAccountLanguage.vue?vue&type=script&lang=js"
export * from "./ManageAccountLanguage.vue?vue&type=script&lang=js"

import "./ManageAccountLanguage.vue?vue&type=style&index=0&id=c54872d2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c54872d2"]])

export default __exports__